var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ImpersonationModal',{attrs:{"message":"enter the company name","search":_setup.search,"minimum-search-length":2},on:{"selected":function($event){return _setup.select($event)},"close":function($event){return _setup.close()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }